<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>院校</el-breadcrumb-item>
        <el-breadcrumb-item>报考信息</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">报考信息</h2>
        </div>
        <div class="right">
          <!--       <el-button
            class="button"
            type="primary"
            @click="createDialog = true"
          >创建</el-button> -->
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <div class="form-wrap">
          <el-form-item label="专业">
            <el-select
              v-model="query.major_door_code"
              placeholder="请选择专业门类"
              clearable
              @change="majorDoorChange"
            >
              <el-option
                v-for="(item,index) in majorList"
                :key="index"
                :label="item.name"
                :value="item.code"
              >
                ({{item.code}}) {{item.name}}
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="query.major_discipline_code"
              placeholder="请选择专业学科"
              clearable
              @change="majorDisciplineChange"
            >
              <el-option
                v-for="(item,index) in majorDisciplineList"
                :key="index"
                :label="item.name"
                :value="item.code"
              >
                ({{item.code}}) {{item.name}}
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="query.major"
              placeholder="请选择专业"
              clearable
              @change="majorChange"
            >
              <el-option
                v-for="(item,index) in majorChildrenList"
                :key="index"
                :label="item.name"
                :value="{ value: item.code, label: item.name}"
              >
                ({{item.code}}) {{item.name}}
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-wrap">
          <el-form-item label="院校">
            <el-select
              v-model="query.college_province_area"
              placeholder="请选择地区"
              @change="$forceUpdate()"
              clearable
            >
              <el-option
                v-for="(item,index) in filters.province_area"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
                                <el-select
              v-model="query.college_province_code"
              placeholder="请选择省份代码"
              @change="$forceUpdate()"
              clearable
            >
              <el-option
                v-for="item in provinces"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="query.college_category_ids"
              placeholder="请选择院校类型"
              @change="$forceUpdate()"
              clearable
            >
              <el-option
                v-for="item in filters.college_category_ids"
                :key="item.code"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="query.college_name_keyword"
              placeholder="请选择院校"
              filterable
              clearable
            >
              <el-option
                v-for="(item,index) in collegeList"
                :key="index"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-wrap">
          <el-form-item label="综合">
            <el-select
              v-model="query.is_first_college"
              placeholder="是否为一流高校"
              clearable
              @change="$forceUpdate()"
            >
              <el-option
                label="是"
                value="1"
              >
              </el-option>
              <el-option
                label="否"
                value="0"
              >
              </el-option>
              <el-option
                label="自主确定，仅清华北大"
                value="2"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select
              v-model="query.is_first_discipline"
              placeholder="是否为一流学科"
              clearable
              @change="$forceUpdate()"
            >
              <el-option
                label="是"
                value="1"
              >
              </el-option>
              <el-option
                label="否"
                value="0"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select
              v-model="query.recommend_levels"
              placeholder="请选择推荐等级"
              clearable
              @change="$forceUpdate()"
            >
              <el-option
                v-for="item in filters.recommend_level"
                :key="item.code"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-wrap">
          <el-form-item label="招生">
            <el-input
              style="width:180px;"
              v-model="query.recruit_cmp_college_major_user_count_first_notlow"
              placeholder="一志愿招生不低于人数"
              oninput="value=value.replace(/[^0-9.]/g,'')"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              style="width:180px;"
              v-model="query.recruit_cmp_college_major_user_count_adjust_notlow"
              placeholder="调剂招生不低于人数"
              oninput="value=value.replace(/[^0-9.]/g,'')"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              style="width:180px;"
              v-model="query.recruit_cmp_college_major_low_score_nothigh"
              placeholder="录取最低分不高于人数"
              oninput="value=value.replace(/[^0-9.]/g,'')"
              clearable
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-wrap">
          <el-form-item label="考试">
            <el-input
              style="width:180px;"
              v-model="query.directions_keyword"
              placeholder="请输入研究方向关键词"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              style="width:180px;"
              v-model="query.subjects_keyword"
              placeholder="请输入考试科目关键词"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              style="width:180px;"
              v-model="query.reference_books_keyword"
              placeholder="请输入参考书目关键词"
              clearable
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div class="divider"></div>
      <div class="action-wrap">
        <el-button
          type="primary"
          size="small"
          @click="handleSearch"
        >搜索</el-button>
        <el-button
          size="small"
          @click="openReportDialog"
        >查看院校报告</el-button>
      </div>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">信息列表</h3>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
          @sort-change="sortChange"
          v-loading="loading"
        >
          <el-table-column
            prop="id"
            label="ID"
            width="80"
            fixed="left"
            align="center"
          ></el-table-column>
          <el-table-column
            label="专业名称"
            width="200  "
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{scope.row.major_code}}{{scope.row.major_name}}
            </template>
          </el-table-column>
          <el-table-column
            label="院校信息"
            align="center"
          >
            <el-table-column
              prop="college_province_area"
              label="地区"
              width="100"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="college_province_name"
              label="所在地"
              width="100"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="college_name"
              label="院校名称"
              width="260"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <div>
                  <span class="tag">{{scope.row.college_name}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="院校类型"
              width="260"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-tag
                  size="mini"
                  v-for="(item,index) in formateCategory(scope.row.college_category_ids)"
                  :key="index"
                >{{item}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="college_rank"
              label="综合排名"
              width="100"
              align="center"
              show-overflow-tooltip
              sortable
            >
              <template slot-scope="scope">
                {{scope.row.college_rank?`${scope.row.college_rank}名`:'暂无'}}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            label="招生数据（全日制）"
            align="center"
          >
            <el-table-column
              prop="recruit_cmp_college_major_user_count_first"
              label="一志愿人数"
              width="120"
              align="center"
              show-overflow-tooltip
              sortable
            >
              <template slot-scope="scope">
                {{scope.row.recruit_cmp_college_major_user_count_first||0}}人
              </template>
            </el-table-column>
            <el-table-column
              prop="recruit_cmp_college_major_user_count_adjust"
              label="调剂人数"
              width="120"
              align="center"
              show-overflow-tooltip
              sortable
            >
              <template slot-scope="scope">
                {{scope.row.recruit_cmp_college_major_user_count_adjust||0}}人
              </template>
            </el-table-column>
            <el-table-column
              prop="recruit_cmp_college_major_low_score"
              label="录取最低分"
              width="120"
              align="center"
              show-overflow-tooltip
              sortable
            >
              <template slot-scope="scope">
                {{scope.row.recruit_cmp_college_major_low_score||0}}分
              </template>
            </el-table-column>
            <el-table-column
              prop="recruit_cmp_college_major_high_score"
              label="录取最高分"
              width="120"
              align="center"
              show-overflow-tooltip
              sortable
            >
              <template slot-scope="scope">
                {{scope.row.recruit_cmp_college_major_high_score||0}}分
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            label="综合信息"
            align="center"
          >
            <el-table-column
              label="一流高校"
              width="100"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <div v-if="scope.row.is_first_college==0">
                  否
                </div>
                <div v-if="scope.row.is_first_college==1">
                  <span class="tag">是</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="一流学科"
              width="100"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <div v-if="scope.row.is_first_discipline==0">
                  否
                </div>
                <div v-if="scope.row.is_first_discipline==1">
                  <span class="tag">是</span>
                </div>
                <div v-if="scope.row.is_first_discipline==2">
                  <span class="tag">自主确定</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="college_major_rank"
              label="专业排名"
              width="150"
              align="center"
              show-overflow-tooltip
              sortable
            >
              <template slot-scope="scope">
                {{scope.row.college_major_rank?`${scope.row.college_major_rank}名`:'暂无'}}
              </template>
            </el-table-column>
            <el-table-column
              label="推荐等级"
              width="150"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{formateLevel(scope.row.recommend_level)}}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            label="操作"
            width="120"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="handleToDetail(scope.row)"
              >详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <div></div>
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <CollegeInfoDetail
      :isVisible="detailDialog"
      @close="detailDialog=false"
      :id="detailId"
    />
    <RankReport
      :isVisible="reportDialog"
      @close="reportDialog=false"
      :major="query.major"
    />
  </div>
</template>

<script>

import { corelist, majorList, provinceList, collegeList } from "@/api/common";


import CollegeInfoDetail from '@/components/dialog/college/CollegeInfoDetail.vue'
import RankReport from '@/components/dialog/college/RankReport.vue'







export default {
  components: {
    CollegeInfoDetail,
    RankReport
  },
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      results: [],
      createDialog: false,
      editDialog: false,
      editId: null,
      chooseList: [],
      createDatetime: "",
      filters: {
        college_category_ids: [
          { value: 0, label: '双非' },
          { value: 1, label: '985' },
          { value: 2, label: '211' },
          { value: 3, label: '一流大学' },
          { value: 4, label: '一流学科' },
          { value: 5, label: '自主划线' }
        ],
        recommend_level: [
          { value: 0, label: '二本三本可报考' },
          { value: 1, label: '一本二本可报考' },
          { value: 2, label: '211/双一流可报考' },
          { value: 3, label: '985/211可报考' },
          { value: 4, label: '不推荐报考' },
        ],
        province_area: [
          { value: '华北地区', label: '华北地区' },
          { value: '西北地区', label: '西北地区' },
          { value: '东北地区', label: '东北地区' },
          { value: '华东地区', label: '华东地区' },
          { value: '华中地区', label: '华中地区' },
          { value: '华南地区', label: '华南地区' },
          { value: '西南地区', label: '西南地区' },
        ]

      },
      detailDialog: false,
      detailId: null,
      reportDialog: false,
      majorList: [],
      majorDisciplineList: [],
      majorChildrenList: [],
      provinces: [],
      collegeList: [],
      loading: false,
    };
  },
  watch: {
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.start_create_time = this.$moment(value[0]).valueOf();
        this.query.end_create_time = this.$moment(value[1]).valueOf();
      } else {
        this.query.start_create_time = "";
        this.query.end_create_time = "";
        this.fetchList(true)
      }
    },
  },
  created() {
    this.fetchMajorList()
    this.fetchProvinceList()
    this.fetchCollegeList()
  },
  methods: {
    fetchList(isReset = false) {
      this.loading = true
      if (isReset) {
        this.query.pageIndex = 1
      }
      const params = Object.assign({}, this.query);
      if (this.query.major) {
        params.major_code = this.query.major.value
      }
      corelist(params).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
        this.loading = false
      });
      this.syncQuery();
    },
    // 院校列表请求
    fetchCollegeList() {
      collegeList({ isPaging: 0 }).then(res => {
        this.collegeList = res.list
      })
    },
    // 省份列表请求
    fetchProvinceList() {
      provinceList().then(res => {
        this.provinces = res.list
      })
    },
    fetchMajorList() {
      majorList({ isPaging: 0 }).then((res) => {
        res.list.forEach((item, index) => {
          this.majorList = this.majorList.concat(item.children)
        })
        this.parseQuery()
        this.fetchList()
        this.$forceUpdate()
      });
    },

    majorDoorChange(e) {
      if (e) {
        this.query.major_discipline_code = null
        this.query.major_code = ''
        this.majorDisciplineList = this.majorList.find(v => {
          return v.code == e
        }).children
      }
    },
    majorDisciplineChange(e) {
      if (e) {
        this.query.major_code = ''
        this.majorChildrenList = this.majorDisciplineList.find(v => {
          return v.code == e
        }).children
      }
      this.$forceUpdate()

    },
    majorChange(e) {
      this.$forceUpdate()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchList();
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchList();
    },


    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
      if (this.query.major) {
        this.query.major = JSON.parse(this.query.major)
      }
      if (this.query.major_door_code) {
        this.majorDisciplineList = this.majorList.find(v => { return v.code == this.query.major_door_code }).children
      }
      if (this.query.major_discipline_code) {
        this.majorChildrenList = this.majorDisciplineList.find(v => { return v.code == this.query.major_discipline_code }).children
      }

    },
    // 同步URL请求参数
    syncQuery() {
      const params = Object.assign({}, this.query);

      let isSync = Object.keys(params).some(
        (key) => this.$route.query[key] != params[key]
      );
      if (params.major) {
        params.major = JSON.stringify(params.major)
      }
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, params),
        });
    },
    formateCategory(val) {
      if (val) {
        let arr = val.split(',')
        let final = arr.map(v => {
          return this.filters.college_category_ids.find(t => {
            return t.value == v
          }).label
        })
        return final
      } else {
        return []
      }
    },
    formateLevel(val) {
      if (val) {
        return this.filters.recommend_level[val].label
      } else {
        return "暂无"
      }
    },
    handleToDetail(row) {
      this.detailId = row.id
      this.detailDialog = true
    },
    openReportDialog() {
      if (!this.query.major) {
        this.$message.error('请选择专业')
        return
      }
      this.reportDialog = true 
    },
    sortChange(col) {
      // ascending升序
      // descending降序
      delete this.query.order_college_rank_asc
      delete this.query.order_college_major_rank_asc
      delete this.query.order_user_count_first_asc
      delete this.query.order_user_count_adjust_asc
      delete this.query.order_low_socre_asc
      delete this.query.order_high_socre_asc
      if (col.prop == "college_rank") {//院校排名排序是否升序
        if (col.order == "ascending") {
          this.query.order_college_rank_asc = 1
        } else if (col.order == "descending") {
          this.query.order_college_rank_asc = 0
        }
      } else if (col.prop == "college_major_rank") {//院校专业排名排序是否升序
        if (col.order == "ascending") {
          this.query.order_college_major_rank_asc = 1
        } else if (col.order == "descending") {
          this.query.order_college_major_rank_asc = 0
        }
      } else if (col.prop == "recruit_cmp_college_major_user_count_first") {//一志愿录取人数排序是否升序
        if (col.order == "ascending") {
          this.query.order_user_count_first_asc = 1
        } else if (col.order == "descending") {
          this.query.order_user_count_first_asc = 0
        }
      } else if (col.prop == "recruit_cmp_college_major_user_count_adjust") {//调剂录取人数排序是否升序
        if (col.order == "ascending") {
          this.query.order_user_count_adjust_asc = 1
        } else if (col.order == "descending") {
          this.query.order_user_count_adjust_asc = 0
        }
      } else if (col.prop == "recruit_cmp_college_major_low_score") {//一志愿录取最低分排序是否升序
        if (col.order == "ascending") {
          this.query.order_low_socre_asc = 1
        } else if (col.order == "descending") {
          this.query.order_low_socre_asc = 0
        }
      } else if (col.prop == "recruit_cmp_college_major_high_score") {//一志愿录取最高分排序是否升序
        if (col.order == "ascending") {
          this.query.order_high_socre_asc = 1
        } else if (col.order == "descending") {
          this.query.order_high_socre_asc = 0
        }
      }
      this.fetchList()
    }


  },
};
</script>

<style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
    }
  }
}
.el-link {
  font-size: 12px;
  margin: 0px 5px;
}
.el-tag {
  margin: 0px 5px;
}
.tag-wrap {
  text-align: left;
}
.tag {
  padding: 3px 6px;
  background: rgba(64, 158, 255, 0.102);
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
}
</style>
